import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetVehicleNewsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object<Repository>} deps.repository
   */
  constructor({config, repository}) {
    super()
    this._config = config
    this._repository = repository
  }

  /**
   * @param {Number} adId
   * @return {Promise<GetVehicleNewsService, Error>}
   */
  @inlineError
  async execute({count, make, model, year}) {
    const [getVehicleNewsError, getVehicleNewsResponse] = await this._repository.getVehicleNews({
      count,
      make,
      model,
      year
    })

    if (getVehicleNewsError) return Promise.reject(getVehicleNewsError)
    return getVehicleNewsResponse
  }
}
